<div class="d-flex flex-column min-vh-100">
  <ToastWrapper />
  <LoaderUI v-show="loader.globalLoading" fullscreen />
  <Navbar />
  <div class="nav-spacer"></div>
  <div class="app-content d-flex flex-column flex-grow-1">
    <router-view v-slot="{ Component }">
      <component :is="Component" v-if="Component" class="flex-grow-1 min-h-0" />
      <LoaderUI v-else class="flex-grow-1" />
    </router-view>
  </div>
  <Footer />
  <LoginDialog v-if="showAuth"
  v-model:visible="isLoginVisible" @closed="handleCloseLogin"/>
</div>
